import type en from '../en/subscriptions'
import type { Translation } from '../types'

/** Alert subscriptions: who is told when a network or device goes offline */
const subscriptions: Translation<typeof en> = {
  "subscriptions.scope.SITE": "Réseau uniquement",
  "subscriptions.scope.SITE_AND_DEVICES": "Réseau + appareils",
  "subscriptions.scope.DEVICE": "Un seul appareil",
  "subscriptions.blurb.SITE": "Alerte lorsque le site lui-même passe hors ligne",
  "subscriptions.blurb.SITE_AND_DEVICES": "Alerte aussi pour chaque appareil qu’il contient",
  "subscriptions.blurb.DEVICE": "Alertes pour un seul appareil",
  "subscriptions.blurbDevices": { one: "Alerte aussi pour chaque appareil qu’il contient ({count} appareil)", other: "Alerte aussi pour chaque appareil qu’il contient ({count} appareils)" },
  "subscriptions.channel.EMAIL": "E-mail",
  "subscriptions.unsubscribed": "Désabonné",
  "subscriptions.testSent": "Test envoyé par {channels}",
  "subscriptions.someFailed": "Certains canaux ont échoué",
  "subscriptions.testFailed": "Échec du test",
  "subscriptions.title": "Abonnements aux alertes",
  "subscriptions.subtitle": "Soyez prévenu lorsqu’un réseau ou un appareil passe hors ligne",
  "subscriptions.subscribe": "S’abonner",
  "subscriptions.noPhone": "Aucun numéro de téléphone défini",
  "subscriptions.ready": "prêt",
  "subscriptions.unavailable": "indisponible",
  "subscriptions.empty": "Aucun abonnement pour l’instant. Abonnez-vous à un réseau pour être prévenu lorsqu’il tombe.",
  "subscriptions.unknown": "Inconnu",
  "subscriptions.paused": "en pause",
  "subscriptions.alertsAfter": "Alerte après {duration} d’interruption",
  "subscriptions.reminderEvery": "Rappel toutes les {duration}",
  "subscriptions.reminderEveryMax": "Rappel toutes les {duration} ({max} au maximum)",
  "subscriptions.oneMessage": "Un message par interruption",
  "subscriptions.recoveryOn": "Avis de rétablissement activé",
  "subscriptions.quiet": "Silence {from}–{to}",
  "subscriptions.muted": "En sourdine :",
  "subscriptions.unmute": "Réactiver",
  "subscriptions.unmuted": "{name} réactivé",
  "subscriptions.mutedName": "{name} mis en sourdine",
  "subscriptions.muteDevice": "Mettre un appareil de ce réseau en sourdine",
  "subscriptions.history": "Historique des envois",
  "subscriptions.sendTest": "Envoyer un test",
  "subscriptions.unsubscribe": "Se désabonner",
  "subscriptions.unsubscribeConfirm": "Se désabonner de ces alertes ?",
  "subscriptions.historyEmpty": "Aucune alerte envoyée pour l’instant — rien n’est passé hors ligne depuis votre abonnement.",
  "subscriptions.target": "Cible",
  "subscriptions.downSince": "Hors ligne depuis",
  "subscriptions.messages": "Messages",
  "subscriptions.state": "État",
  "subscriptions.reminders": { one: "({count} rappel)", other: "({count} rappels)" },
  "subscriptions.state.PENDING": "en attente",
  "subscriptions.state.NOTIFIED": "envoyé",
  "subscriptions.state.RECOVERED": "rétabli",
  "subscriptions.newTitle": "S’abonner aux alertes",
  "subscriptions.network": "Réseau *",
  "subscriptions.chooseNetwork": "Choisissez un réseau…",
  "subscriptions.watchWhat": "Que souhaitez-vous surveiller ?",
  "subscriptions.device": "Appareil *",
  "subscriptions.chooseDevice": "Choisissez un appareil…",
  "subscriptions.sendVia": "Envoyer les alertes par *",
  "subscriptions.rcsNote": "Le RCS arrive dans l’application de messages du téléphone. Il n’atteint pas encore les iPhone aux Pays-Bas.",
  "subscriptions.rcsNoteTwilio": "Le RCS arrive dans l’application de messages du téléphone. Il n’atteint pas encore les iPhone aux Pays-Bas ; avec un numéro SMS dans le service Twilio, ils reçoivent un SMS.",
  "subscriptions.howOften": "Fréquence",
  "subscriptions.wait": "Attendre avant d’alerter",
  "subscriptions.waitHint": "minutes — ignore les brèves coupures et les redémarrages",
  "subscriptions.remind": "Me le rappeler tant que c’est hors ligne",
  "subscriptions.remindHint": "Désactivé par défaut — vous recevez exactement un message par interruption.",
  "subscriptions.every": "toutes les",
  "subscriptions.remindEvery": "Rappeler toutes les",
  "subscriptions.stopAfter": "arrêter après",
  "subscriptions.stopAfterLabel": "Arrêter après ce nombre de rappels",
  "subscriptions.remindersWord": "rappels",
  "subscriptions.recovers": "Me prévenir lorsque c’est rétabli",
  "subscriptions.recoversHint": "Un message lorsqu’il revient en ligne",
  "subscriptions.quietHours": "Heures de silence",
  "subscriptions.quietHint": "Les messages sont retenus jusqu’à la fin de la plage",
  "subscriptions.quietStart": "Début des heures de silence",
  "subscriptions.quietEnd": "Fin des heures de silence",
  "subscriptions.to": "à",
  "subscriptions.subscribed": "Abonné",
  "subscriptions.subscribeFailed": "L’abonnement a échoué",
  "subscriptions.devicesIn": "Appareils de {name}",
  "subscriptions.muteInfo": "Mettez un appareil en sourdine pour arrêter ses alertes tout en gardant le reste du réseau abonné.",
  "subscriptions.noDevices": "Aucun appareil trouvé sur ce réseau",
  "subscriptions.unmuteTitle": "Réactiver — reprendre les alertes",
  "subscriptions.muteTitle": "Sourdine — arrêter les alertes de cet appareil",
  "subscriptions.mute": "Sourdine",
  "subscriptions.done": "Terminé",
  "subscriptions.notChanged": "Non modifié",
  "subscriptions.channel.PUSH": "Push (application mobile)",
  "subscriptions.pushPhones": "Téléphones avec push : {n}",
  "subscriptions.pushFirst.first": {"one": "Le push part d’abord. {channel} suit après {count} minute si vous n’avez pas ouvert le site.", "other": "Le push part d’abord. {channel} suit après {count} minutes si vous n’avez pas ouvert le site."},
  "subscriptions.pushFirst.atOnce": "{channel} part tout de suite : aucun de vos téléphones n’autorise le push (Profil → Application mobile).",
  "subscriptions.pushFirst.automatic": "Le push part de toute façon d’abord pour vos alertes WhatsApp et RCS.",
}

export default subscriptions
